import { render, staticRenderFns } from "./NuxtImage.vue?vue&type=template&id=0d257160"
import script from "./NuxtImage.vue?vue&type=script&lang=js"
export * from "./NuxtImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports